import { render, staticRenderFns } from "./MspForsageMember.vue?vue&type=template&id=4b995826&"
import script from "./MspForsageMember.vue?vue&type=script&lang=js&"
export * from "./MspForsageMember.vue?vue&type=script&lang=js&"
import style0 from "./MspForsageMember.vue?vue&type=style&index=0&id=4b995826&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports